import React, { useState, useContext, useEffect } from 'react';
import axios from 'axios';

import useInput from '../../hooks/useInput';
import ForgotPasswordValidator from '../../helpers/validators/forgot-password.validator';
import TextInput from '../common/InputWithLabel';
import Error from '../common/Error';
import AuthenticationDispatch from '../../contexts/authenticationDispatch';
import authenticationActions from '../../actions/authentication.actions';
import SubmitButton from '../common/PrimaryButton';
import findErrorField from '../../helpers/serverError';

import style from './ForgotPasswordForm.module.css';

const ForgotPasswordForm = React.memo(() => {
  const emailAddress = useInput('');
  const [errors, setErrors] = useState({ emailAddress: '' });
  const [serverError, setServerError] = useState('');
  const [resetPasswordRequested, setResetPasswordRequested] = useState(false);
  const dispatch = useContext(AuthenticationDispatch);

  useEffect(() => {
    const handleSuccess = () => {
      dispatch({
        type: authenticationActions.RESET_PASSWORD_REQUEST_SUCCESS,
        resetPasswordRequested,
      });
    };

    const handleError = ({ response }) => {
      if (response && response.data && response.data.ValidationErrors) {
        const emailAddressError = findErrorField(
          response.data.ValidationErrors,
          'EmailAddress',
        );

        setErrors({
          emailAddress: emailAddressError.Messages[0],
        });
      } else {
        setServerError('Something went wrong. Please try again.');
      }

      setResetPasswordRequested(false);
    };

    if (resetPasswordRequested) {
      axios
        .post(`${process.env.REACT_APP_BASE_URL}account/reset-password`, {
          EmailAddress: emailAddress.value,
        })
        .then(handleSuccess)
        .catch(handleError);
    }
  }, [dispatch, emailAddress.value, resetPasswordRequested]);

  const onSubmit = event => {
    event.preventDefault();

    const validation = ForgotPasswordValidator.validate({
      emailAddress: emailAddress.value,
    });

    setErrors({
      emailAddress: validation.emailAddress.message,
    });

    setServerError('');

    if (validation.isValid) {
      setResetPasswordRequested(true);
    }
  };

  return (
    <form onSubmit={onSubmit}>
      <p className={style.note}>
        All users logging in for the first time are required to reset their
        passwords. Enter your email below to begin.
      </p>
      <TextInput
        type="text"
        name="emailAddress"
        label="Enter Your Email Address"
        autocomplete="off"
        error={errors.emailAddress}
        {...emailAddress}
      />
      {serverError && <Error error={serverError} />}
      <SubmitButton text="Submit" />
    </form>
  );
});

export default ForgotPasswordForm;
